"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rcSlider = _interopRequireDefault(require("rc-slider"));
var Range = function Range(_ref) {
  var min = _ref.min,
    max = _ref.max,
    onRangeChange = _ref.onRangeChange,
    valueMin = _ref.valueMin,
    valueMax = _ref.valueMax,
    customValuesDisplay = _ref.customValuesDisplay;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "d8-c-range"
  }, /*#__PURE__*/_react["default"].createElement(_rcSlider["default"], {
    range: true,
    min: min,
    max: max,
    defaultValue: [valueMin, valueMax],
    onChange: function onChange(val) {
      return onRangeChange(val);
    }
  }), !customValuesDisplay && /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex flex-center margin-top-md"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-bold"
  }, valueMin), " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm d8-u-color-contrast-high"
  }, "guests")), /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-bold margin-x-md"
  }, "-"), /*#__PURE__*/_react["default"].createElement("div", {
    className: ""
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "d8-u-text-bold"
  }, valueMax), " ", /*#__PURE__*/_react["default"].createElement("span", {
    className: "text-sm d8-u-color-contrast-high"
  }, "guests"))), customValuesDisplay && customValuesDisplay());
};
Range.propTypes = {
  min: _propTypes["default"].number,
  max: _propTypes["default"].number,
  valueMin: _propTypes["default"].number,
  valueMax: _propTypes["default"].number,
  onRangeChange: _propTypes["default"].func.isRequired,
  customValuesDisplay: _propTypes["default"].func
};
var _default = exports["default"] = Range;